import logger from './logger';

/**
 * Our merchant config objects are not normalized. This means that sometimes boolean values are set
 * to the strings "true" or "false", and we have to account for those appropriately.
 * @param {any} value ex. "true" | "false" we are converting to bool
 * @returns {boolean} normalized value to boolean
 */
export default function isTrue(value) {
  if (typeof value === 'string') {
    return value.toLowerCase() === 'true';
  }

  if (typeof value !== 'boolean') {
    logger(
      `isTrue only accepts a boolean or a stringified boolean argument (i.e. "true" | "false"). Received \`${typeof value}\` instead.`
    );
    return false;
  }

  return value;
}
